
export const getCalibrationValuesPending = () => {
    return {
        type: 'GET_CALIBRATION_VALUES_PENDING'
    }
};

export const getCalibrationValuesSuccess = (calibrationValues, page, pageCount, itemsCount) => {
    return {
        type: 'GET_CALIBRATION_VALUES_SUCCESS',
        calibrationValues,
        page,
        pageCount,
        itemsCount
    }
};

export const getCalibrationValuesError = error => {
    return {
        type: 'GET_CALIBRATION_VALUES_ERROR',
        error: error
    }
};

export const selectCalibrationValue = (calibrationValue) => {
    return {
        type: 'SELECT_CALIBRATION_VALUE',
        selected: { calibrationValue }
    };
};

export const getCalibrationMeasurementTypesSuccess = (calibrationMeasurementTypes) => {
    return {
        type: 'GET_CALIBRATION_MEASUREMENT_TYPES_SUCCESS',
        calibrationMeasurementTypes
    }
};

export const getCalibrationMeasurementTypesError = error => {
    return {
        type: 'GET_CALIBRATION_MEASUREMENT_TYPES_ERROR',
        error: error
    }
};

export const getCalibrationValues = () => {

    return dispatch => {
        dispatch(getCalibrationValuesPending());

        fetch(`${process.env.REACT_APP_API_URL}/calibration/getAllCalibrationValueSets`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getCalibrationValuesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                if (res.length) {
                    dispatch(selectCalibrationValue(res[0]))
                }
                dispatch(getCalibrationValuesSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const addCalibrationValue = obj => {
    return dispatch => {
        dispatch(getCalibrationValuesPending());

        fetch(`${process.env.REACT_APP_API_URL}/calibration/addCalibrationValueSet`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj),
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getCalibrationValues());
                } else {
                    dispatch(getCalibrationValuesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};


export const updateCalibrationValue = obj => {
    return dispatch => {
        dispatch(getCalibrationValuesPending());

        fetch(`${process.env.REACT_APP_API_URL}/calibration/updateCalibrationValueSet`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj),
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getCalibrationValues());
                } else {
                    dispatch(getCalibrationValuesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};


export const deleteCalibrationValue = (id) => {
    return dispatch => {
        dispatch(getCalibrationValuesPending());

        fetch(`${process.env.REACT_APP_API_URL}/calibration/deleteCalibrationValueSet?setId=${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getCalibrationValues());
                } else {
                    dispatch(getCalibrationValuesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};


export const getCalibrationMeasurementTypes = () => {

    return dispatch => {
        dispatch(getCalibrationValuesPending());

        // fetch(`${process.env.REACT_APP_API_URL}/alert_measurement_types_extended`, {
        fetch(`${process.env.REACT_APP_API_URL}/calibration/calibration_measurement_types`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getCalibrationMeasurementTypesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                // if (res.length) {
                //     dispatch(selectAlertRule(res[0]))
                // }
                dispatch(getCalibrationMeasurementTypesSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};
